var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store_goods_list"},[_c('div',{staticClass:"shop_top"},[_c('shop-top')],1),_c('div',[_c('banner',{attrs:{"list":_vm.banner_list,"height":'300'}})],1),_c('div',{staticClass:"store_body"},[_c('store-class-product')],1),_c('shop-foot'),_c('el-backtop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }